var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"club-step__billing-message"},[_c('div',[_c('p',[_vm._v("Your selection is almost ready!")]),_vm._v(" "),_c('a',{staticClass:"btn-primary",attrs:{"href":_vm.link}},[_vm._v("Add your credit card to complete it")])])])}
var staticRenderFns = []

export { render, staticRenderFns }